<div class="message" [ngClass]="{'message-user': isUser, 'message-assistant': isAssistant, 'message-error': isError}">
  <div class="message-avatar">
    <app-titan-icon *ngIf="isUser" [variant]="'Unisex'" [size]="'l'"></app-titan-icon>
    <app-titan-icon *ngIf="isAssistant" [variant]="'Sparks'" [size]="'l'" class="color-orange-500"></app-titan-icon>
  </div>
  <div class="message-content">
    <div class="message-header">
      <span class="message-role">{{ isUser ? 'You' : 'AI Assistant' }}</span>
    </div>
    <div class="message-text" [ngClass]="{'error-text': isError}">
      <app-titan-icon *ngIf="isError" [variant]="'Alert'" [size]="'s'" class="error-icon"></app-titan-icon>
      <span *ngIf="isUser">{{ message.content }}</span>
      <div *ngIf="isAssistant" [innerHTML]="message.content | markdown"></div>
    </div>
    <button *ngIf="isError && message.retryPrompt" class="retry-button" (click)="onRetryClick()">
      <app-titan-icon [variant]="'Refresh'" [size]="'s'"></app-titan-icon>
      <span>Try again</span>
    </button>
  </div>
</div>
